import { View } from 'foundations-components/components/View';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import { FeatureName } from '../../features/FeatureName';
import { TranslatedHtmlContent } from './FeatureCell';
import { IncludesFeatureIcon } from './IncludesFeatureIcon';
import { TableCellWrapperWithHoverTracking } from './TableCellWrapperWithHoverTracking';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const ChildFeatureRow = ({
  isParentFeatureInBeta,
  childFeature,
  productApiNames,
  trackingProperties
}) => {
  return /*#__PURE__*/_jsxs(View, {
    as: "tr",
    children: [/*#__PURE__*/_jsx(TableCellWrapperWithHoverTracking, {
      trackingProperties: Object.assign({}, trackingProperties, {
        tableColumn: 'displayName'
      }),
      children: /*#__PURE__*/_jsx(Tooltip, {
        disabled: childFeature.featureDescription.featureDescription === '',
        placement: "right",
        title: /*#__PURE__*/_jsx(TranslatedHtmlContent, {
          htmlContent: childFeature.featureDescription.featureDescription
        }),
        children: /*#__PURE__*/_jsx(View, {
          marginInlineStart: "400",
          paddingInlineEnd: "400",
          children: /*#__PURE__*/_jsx(FeatureName, {
            featureDisplayName: childFeature.displayName
            // To reduce visual noise, hide the beta badge if the parent feature
            // is also in beta
            ,
            isBeta: !isParentFeatureInBeta && childFeature.isBeta,
            textStyles: {
              typography: 'body-100'
            }
          })
        })
      })
    }), productApiNames.map(apiName => {
      var _childFeature$feature;
      const limitDescriptionByProduct = (_childFeature$feature = childFeature.featureDescription.limitDescriptions.limitDescriptionsByProduct) === null || _childFeature$feature === void 0 ? void 0 : _childFeature$feature[apiName];
      return /*#__PURE__*/_jsx(View, {
        as: "td",
        children: !childFeature.associatedProducts.includes(apiName) ? undefined : limitDescriptionByProduct ? /*#__PURE__*/_jsx(TranslatedHtmlContent, {
          htmlContent: limitDescriptionByProduct
        }) : /*#__PURE__*/_jsx(IncludesFeatureIcon, {})
      }, apiName);
    })]
  });
};